import { html } from 'lit'
import { handleize } from '../../lib/utils'

import store from '../store/index.js'
import router from './store.js'

/**
 * Routes for the quiz app
 * Each route will render one specific component
 */
export default [
  {
    path: '',
    name: 'intro',
    component: 'hh-quiz-view-intro',
  },
  {
    path: '/summary',
    name: 'summary',
    /**
     * Navigation guard to check if all questions are completed
     * @param {String} path
     * @param {Object} route
     * @returns {String} parsed path
     */
    before: (path) => {
      // Test is not completed
      if (!store.testIsCompleted) {
        return router.lastAvailablePath
      }
      Shopify?.analytics?.publish('quiz_complete', {});
      return path
    },
    component: `hh-quiz-view-summary`,
    hideNavigation: true,
    children: [
      {
        path: ':handle',
        name: 'results',
        component: `hh-quiz-view-results`,
        hideNavigation: true,
      },
    ]
  },
  {
    path: ':category',
    name: 'category',
    component: 'hh-quiz-not-found',
    children: [
      {
        path: ':handle',
        name: 'question',
        /**
         * Navigation guard to check if the question is enabled and exists
         * @param {String} path
         * @param {Object} route
         * @returns {String} parsed path
         */
        before: (path, route) => {
          const question = store.getQuestion(route.params.handle)

          // question doesn't exist
          if (!question) return '/'

          // question exists but is not enabled (previous question not answered)
          if (!question.isEnabled) {
            return router.lastAvailablePath
          }

          return path
        },
        /**
         * Component to render
         * Dynamic based on if the question exists under the category
         */
        component: ({ handle, category }) => {
          return store.quiz?.questions.find(
            (q) =>
              q.handle === handle && handleize(q.category.handle) === category
          )
            ? 'hh-quiz-view-question'
            : 'hh-quiz-not-found'
        },
      },
      ,
    ],
  },
  {
    name: '404',
    render: () => html`Error 404`,
    component: 'hh-quiz-not-found',
  },
]
